import { Language } from "./types";

export const transformLanguage = (formValues: Language): any => {
  return {
    id: formValues.id,
    name: formValues.name,
  };
};
